import { hideDialog, refresher } from "../../../redux/guest-slices/other.slice"
import { CREATE_BLOG_CATEGORY } from "../../../utils/keywords"
import { useDispatch, useSelector } from "react-redux"
import InputFieldA from "../../ui/InputFieldA"
import Icons from "../../../assets/js/Icons"
import moment from "moment"

import {
  Box, Button, CircularProgress, DialogActions, DialogContent,
  DialogTitle, IconButton, Paper, Stack, Typography
} from "@mui/material"
import { handleUpdateWebinar } from "../../../redux/admin-slices/webinars.slice"

function Webinar() {
  const dispatch = useDispatch()
  const { type, data, loadings } = useSelector(state => state.otherSlice)

  // Close dialog
  const handleClose = () => {
    dispatch(hideDialog())
  }

  // Handle create  
  const handleSubmit = (e) => {
    e.preventDefault()
    const form = e.target
    const formData = Object.fromEntries(new FormData(form))
    dispatch(handleUpdateWebinar({
      formData,
      id: data?.webinar?._id
    })
    ).unwrap().then(() => {
      setTimeout(() => {
        handleClose()
        dispatch(refresher())
      }, 500)
    }).catch(() => { })

  }

  return (
    <Paper component="form" onSubmit={handleSubmit}>
      <DialogTitle sx={{ position: "relative" }}>
        <Typography
          sx={{
            m: "0",
            fontSize: "24px",
            fontWeight: "600",
            textAlign: "center",
          }}
        >Update Webinar
        </Typography>
        <IconButton
          sx={{
            top: "10px",
            right: "10px",
            color: "other.color1",
            position: "absolute",
          }}
          size="small"
          onClick={handleClose}
        ><Icons.CancelSolid />
        </IconButton>
      </DialogTitle>
      <DialogContent
        className="relative"
        sx={{ ".MuiInputBase-root": { borderRadius: "6px" } }}
      >
        <Stack spacing={1.5}>
          <Box>
            <InputFieldA
              type="text"
              name="title"
              label="Title *"
              placeholder="Enter title"
              value={data?.webinar?.details?.title}
            />
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Box sx={{ flexGrow: "1" }}>
              <InputFieldA
                type="date"
                name="date"
                label="Date *"
                value={data?.webinar?.schedule?.startTime ?
                  moment(data?.webinar?.schedule?.startTime).format("YYYY-MM-DD") : ""
                }
                slotProps={{
                  htmlInput: { min: moment().format("YYYY-MM-DD") }
                }}
              />
            </Box>
            <Box sx={{ flexGrow: "1" }}>
              <InputFieldA
                type="time"
                name="startTime"
                label="Start time *"
                value={data?.webinar?.schedule?.startTime ?
                  moment(data?.webinar?.schedule?.startTime).format("HH:mm") : ""
                }
              />
            </Box>
          </Box>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", px: 3 }}>
        <Button
          type="submit"
          color="success"
          variant="contained"
          sx={{ minWidth: 120 }}
          endIcon={(
            loadings?.create ||
            loadings?.update
          ) &&
            <CircularProgress
              size={20}
              thickness={5}
              sx={{ color: "white" }}
            />
          }
        >
          {type === CREATE_BLOG_CATEGORY ?
            "Create" : "Update"
          }
        </Button>
      </DialogActions>
    </Paper>
  )
}

export default Webinar